import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type BeliefSystemsMultiSelectInput_query$key } from '@/__generated__/BeliefSystemsMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'

export type BeliefSystemsMultiSelectInputProps = Omit<MultiSelectInputProps, 'options'> & {
  queryRef: BeliefSystemsMultiSelectInput_query$key | null | undefined
}

export const BeliefSystemsMultiSelectInput = forwardRef<MultiSelectInputRef, BeliefSystemsMultiSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment BeliefSystemsMultiSelectInput_query on Query {
          beliefSystems(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <MultiSelectInput
        options={useMemo<SelectOption[]>(
          () =>
            map(queryData?.beliefSystems?.nodes, (beliefSystem) => ({
              label: beliefSystem!.name,
              value: beliefSystem!.rowId
            })),
          [queryData?.beliefSystems?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

BeliefSystemsMultiSelectInput.displayName = 'BeliefSystemsMultiSelectInput'
